<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Trickle Vents';
                }
            },
            fabricator: {
                required: true,
            },
            frame: {
                required: false,
                default(){
                    return '';
                }
            },
            extra_text: {
                required: false,
                default(){
                    return '';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.fabricator);
            },
            url(){
                return '/api/options/' + this.fabricator + '/trickle-vents';
            },
            cache_key(){
                return '_';
            },
        },
        watch: {
            'cache_key': function (newVal, oldVal) {
                this.update_options();
            },
        },
    }
</script>
